module.exports = __webpack_public_path__ + "img/homebg2.30a73d67.png";